import * as React from 'react';
import Card from "../card/card";
import Share from "../share/share";
import Tags from '../tags/tags'
import { FormattedMessage } from "react-intl";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ReactPlayerLoader from '@brightcove/react-player-loader';
import './articleStandardFeature.scss';

import { Watch } from 'scrollmonitor-react';

library.add(faArrowRight);

const onSuccess = function(success) {
    //console.log(success.ref)
  };
 

class ArticleStandardFeature extends React.Component {
  render() {
    let theBlock = this.props.block;
    let tmpArticle = [];
    let tmpArticles = [];
    let tmpLinkedArticle;    
    let indexOfArticleData = this.props.issueArticles.map(function(o) { return o.articleId; }).indexOf(theBlock.blockLinkedArticle);
    let asideSideClass = theBlock.blockAsideRight ? "order-md-last" : "order-md-first";
    let mainSideClass = theBlock.blockAsideRight ? "order-md-first" : "order-md-last";
    let renderImageBlock = false;
    let renderImage = false;
    let renderVideo = false;
    let accountId = "1460825906";
    let isVid = "true";
    let playerId = "default";
    let embedId = "default";
    let baseUrl = this.props.baseUrl ? this.props.baseUrl : ".";
    let inView = this.props.isInViewport;
    let elementHasBeenInView = this.props.isAboveViewport;
 
    // Change classname based on boolean
    let viewClassName = (inView)? 'is-inview-true' : 'is-inview-false';
    let beenViewed = (elementHasBeenInView)? ' is-viewed' : ' is-not-viewed';

    //get attached article
    tmpLinkedArticle = this.props.issueArticles[indexOfArticleData];

    let videoId = tmpLinkedArticle.articleVideoId ? tmpLinkedArticle.articleVideoId : null;
    
    if(theBlock.blockHeroImage || tmpLinkedArticle.articleVideoId) {
        if(theBlock.blockHeroImage) {
            renderImage = true;
            renderVideo = false;
        }
        if(tmpLinkedArticle.articleVideoId) {
            renderImage = false;
            renderVideo = true;
        }
        renderImageBlock = true;
    }

    //populate new article array with all article data
    if(theBlock.blockLinkedAsideArticles) {
        theBlock.blockLinkedAsideArticles.forEach(function(item) {
            let indexOfArticleData = this.props.issueArticles.map(function(o) { return o.articleId; }).indexOf(item.articleId);
            tmpArticles.push(this.props.issueArticles[indexOfArticleData]);
        }, this);
    }

    if(theBlock){
        tmpArticle = tmpArticles.map(function(article, key) {
            return (
                <Card renderImage={renderImageBlock} key={"card_"+article.articleId+key} baseUrl={baseUrl} issueId={this.props.issueId} cardData={article} changeRoute={this.props.changeRoute} locale={this.props.locale}/>
            )
        }, this);
    }
    return (
        <div className={theBlock.blockHideOnMobile ? viewClassName + beenViewed + " d-none d-md-block " + theBlock.blockType : viewClassName + beenViewed + " " + theBlock.blockType}> 
            <div className="container">
                <div className="row">
                    <div className="col-12 my-sm-4">
                        <div className="row">           
                            <div className={"col-md-7 col-lg-8 " + mainSideClass}>
                                <div className="introBoxOuter">
                                    {renderImage && <div className="is-image"><img src={baseUrl+theBlock.blockHeroImage} alt={theBlock.blockHeroImageAlt} className="img-fluid heroImage"/></div>}
                                    {renderVideo && <ReactPlayerLoader isVid={isVid} playerId={playerId} embedId={embedId} accountId={accountId} videoId={videoId} onSuccess={onSuccess} embedOptions={{responsive: true}}/>}
                                    <div className='introBox'>
                                        <div className="intro-tags"><Tags tags={tmpLinkedArticle.articleTags} readTime={tmpLinkedArticle.articleReadTime} videoId={tmpLinkedArticle.articleVideoId}/></div>
                                        {this.props.pageH1 ? <h1 className="issueTitle">{theBlock.blockTitle}</h1> : <h2 className="issueTitle h1">{theBlock.blockTitle}</h2>}
                                        <div className="issueSummary"><p>{theBlock.blockSummary}</p></div>
                                    </div>
                                    <div className="introBoxFooter">
                                        {!renderVideo &&
                                        <a className='btn btn-primary read-more' onClick={() => {this.props.changeRoute(this.props.issueId, theBlock.blockLinkedArticle)}} href={'./index.html?issueid='+this.props.issueId+'&articleid='+theBlock.blockLinkedArticle+"&lang="+this.props.locale}>
                                            {theBlock.moreButtonText === "" ? (<FormattedMessage id="General.readMore" defaultMessage="Read More" />) : (<span>{theBlock.moreButtonText}</span>)}
                                            <span className="more-arrow"><FontAwesomeIcon icon="arrow-right" /></span>
                                        </a>
                                        }
                                    </div>
                                    <Share />
                                </div>
                            </div>
                            <div className={"col-md-5 col-lg-4 " + asideSideClass}>
                                {tmpArticle}
                            </div>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
  }
}

//const InviewOptions = {offsetY: 0.2, showGuides: false, fullElementInView: false, debounceTime: 30}

export default Watch(ArticleStandardFeature);
